import { PayoutMethodState } from 'modules/host-payout-methods/context/PayoutFormContext';

const appendOrReplace = (current, fresh) => [
  ...current.map(
    (item) => fresh.find((newItem) => newItem.id === item.id) || item,
  ),
  ...fresh.filter((newItem) => !current.some((item) => item.id === newItem.id)),
];

export default function (state: PayoutMethodState, action): PayoutMethodState {
  switch (action.type) {
    case 'FETCH_PAYOUT_METHODS':
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case 'FETCH_PAYOUT_METHODS:SUCCESS':
      return {
        data: appendOrReplace(state.data, action.payoutMethods),
        loading: false,
        error: undefined,
      };
    case 'FETCH_PAYOUT_METHODS:ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };
  }
  return state;
}
